import {Component} from '@angular/core';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {RmeNodeDaoService} from '../../../../core/services/rme-node-dao.service';
import {
  DeleteNodeBaseDialogComponent,
  DeleteNodeBaseDialogModule
} from '../components/delete-node-base-dialog/delete-node-base-dialog.module';

@Component({
  templateUrl: './delete-node-dialog.component.html',
  styleUrls: ['./delete-node-dialog.component.scss'],
  standalone: true,
  imports: [
    DeleteNodeBaseDialogModule,
    DialogCloseButtonComponent,
    ContentLoaderComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent
  ],
  providers: [{provide: DeleteNodeBaseDialogComponent, useValue: DeleteNodeDialogComponent}]
})
export class DeleteNodeDialogComponent extends DeleteNodeBaseDialogComponent {
  setTranslations() {
    if (this.data.multiple) {
      this.translations = {
        title: this.translate.instant('POPUPS.DELETE_NODES'),
        text: this.translate.instant('POPUPS.DELETE_NODES_TEXT')
      };
    } else {
      super.setTranslations();
    }
  }

  deleteNode() {
    if (this.data.multiple) {
      this.deleteMultipleNodes();
    } else {
      super.deleteNode();
    }
  }

  deleteMultipleNodes() {
    this.loading = true;
    this.injector
      .get(RmeNodeDaoService)
      .deleteMultipleNodes(this.data.refModelId)
      .subscribe(
        () => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        () => this.dialogRef.close(false)
      );
  }
}
